module.exports = __webpack_public_path__ + "img/terImg4.46c348ef.png";